// Presentational helper for material lists ("8 wood, 4 stone"). Numbers stay numbers until here.
import type { Resource } from '../../sim/api';
import { resourceLabel } from '../text/en';

export type Materials = Partial<Record<Resource, number>>;

export function amount(x: number): string {
  const r = Math.round(x * 10) / 10;
  return Number.isInteger(r) ? r.toString() : r.toFixed(1);
}

export function materialsText(m: Materials): string {
  const parts = (Object.entries(m) as [Resource, number][])
    .filter(([, n]) => n > 1e-9)
    .map(([r, n]) => `${amount(n)} ${resourceLabel[r].toLowerCase()}`);
  return parts.length === 0 ? '-' : parts.join(', ');
}
